import React from "react";
import newtouText from "../../assets/images/newtou-text.svg";
import secondhandText from "../../assets/images/secondhand-text.svg";
import { useNavigate } from "react-router-dom";

export const SplashScreen = () => {
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = React.useState(true);
  React.useEffect(() => {
    // Simulate the splash screen for 2 seconds
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);
  if (showSplash) {
    return (
      <div className=" bg-white h-screen w-screen flex flex-col justify-center items-center">
        <img
          src={newtouText}
          alt="newtou"
          className="w-[15rem] absolute top-[35%] "
        />
        <img
          src={secondhandText}
          alt="secondhand"
          className="w-[15rem] absolute bottom-10"
        />
      </div>
    );
  }
  // handle the case where the user is not logged in
  // and redirect them to the login page
  if (localStorage.getItem("token") === null) {
    navigate("/login");
  } else {
    navigate("/home");
  }
};
